<template>
  <drag-dialog
    :append-to-body="true"
    :show.sync="dialog"
    :title="isAdd ? '新增角色' : '编辑角色'"
    :enableDrag="true"
    width="500px"
    @close="cancel">
    <dynamic-form :formConfig="formConfig" v-model="form" @submit="doSubmit" @cancelForm="cancel" ref="pageForm"></dynamic-form>
  </drag-dialog>
</template>

<script>
import { add, edit } from '@/api/role'
import DragDialog from '@/components/DragDialog'
import '@/components/dynamic-form';
export default {
  props: {
    isAdd: {
      type: Boolean,
      required: true
    },
    supThis: {
      type: Object,
    }
  },
  components: {
    DragDialog
  },
  data() {
    return {
      loading: false, dialog: false,
      form: {},
      formConfig: {
        formItemList: [
            {
              type: "input",
              key: "name",
              label: "角色名称",
              value: "",
              placeholder: "请输入名称",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
              type: "input",
              key: "code",
              label: "角色编码",
              value: "",
              placeholder: "请输入编码",
              rules: [
                  { required: true, message: "不能为空", trigger: "blur" }
              ]
            },
            {
                type: "radio",
                label: "是否启用",
                value: true,
                button: false,
                border: false,
                key: "enabled",
                options: [
                    {
                        label: '启用',
                        value: true
                    },
                    {
                        label: '禁用',
                        value: false
                    }
                ]
            }
        ]
      }
    }
  },
  watch: {
    dialog(val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.pageForm.$refs.dynamicForm.clearValidate();
        });
      }
    }
  },
  methods: {
    cancel() {
      this.resetForm()
    },
    doSubmit(val) {
      this.form = val
      if (this.isAdd) {
          this.doAdd()
      } else this.doEdit()
    },
    doAdd() {
      add(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '添加成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err)
      })
    },
    doEdit() {
      edit(this.form).then(res => {
        this.resetForm()
        this.$notify({
          title: '修改成功',
          type: 'success',
          duration: 2500
        })
        this.loading = false
        this.supThis.dataTableInit()
      }).catch(err => {
        this.loading = false
        console.log(err.response.data.message)
      })
    },
    resetForm() {
      this.dialog = false
      this.$refs.pageForm.resetForm()
    }
  }
}
</script>

<style scoped>

</style>
